module.exports = __webpack_public_path__ + "img/display cctv dari samping.e64eb02f.jpg";